/* 🤖 this file was generated by svg-to-ts */
export const matIconBookmarkAdded: {
  name: 'bookmark-added';
  data: string;
} = {
  name: 'bookmark-added',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm.83-2L15 6.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L17.83 9z"/></svg>`
};
